import { render, staticRenderFns } from "./pdfGenerator.vue?vue&type=template&id=274e0a1f&scoped=true"
import script from "./pdfGenerator.vue?vue&type=script&lang=js"
export * from "./pdfGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e0a1f",
  null
  
)

export default component.exports